import { atom } from 'nanostores';

export class SuccessPopupStore {
  $isOpened = atom(false);

  store;

  constructor(store) {
    this.store = store;
  }

  open() {
    if (this.$isOpened.get()) return;

    this.$isOpened.set(true);
    this.store.scrollStore.lock('successPopup');
  }

  close() {
    if (!this.$isOpened.get()) return;

    this.$isOpened.set(false);
    this.store.scrollStore.unlock('successPopup');
  }
}
